var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,14.5859a2.5038,2.5038,0,0,0-2-2.4494V10.5859a2.5026,2.5026,0,0,0-2.5-2.5h-.793L12.2676,3.6465a2.5027,2.5027,0,0,0-3.5352,0L4.27,8.1093A2.4944,2.4944,0,0,0,2,10.5859v8a2.5026,2.5026,0,0,0,2.5,2.5h13a2.5026,2.5026,0,0,0,2.5-2.5V17.0353A2.5037,2.5037,0,0,0,22,14.5859ZM9.44,4.3535a1.5012,1.5012,0,0,1,2.121,0L15.293,8.0859H5.707ZM17.5,20.0859H4.5a1.5016,1.5016,0,0,1-1.5-1.5v-8a1.5017,1.5017,0,0,1,1.5-1.5h13a1.5017,1.5017,0,0,1,1.5,1.5v1.5H17.5a2.5,2.5,0,0,0,0,5H19v1.5A1.5016,1.5016,0,0,1,17.5,20.0859Zm2-4h-2a1.5,1.5,0,0,1,0-3h2a1.5,1.5,0,1,1,0,3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.79792ada31cfab3f421e39bcec6d63cc.svg";
export { ForwardRef as ReactComponent };